import * as React from "react";
function SvgPin(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2c-1.124 0-3.087.274-4.803 1.41C5.418 4.59 4 6.643 4 9.955c0 3.347 1.95 6.342 3.745 8.411a25.515 25.515 0 003.335 3.19c.101.08.182.142.238.184l.066.05.019.013.006.005h.001l.001.001L12 21l-.588.809a1 1 0 001.176 0L12 21c.588.809.588.808.589.808l.002-.002.006-.004.018-.013.066-.05a22.629 22.629 0 001.068-.873 25.524 25.524 0 002.506-2.5C18.051 16.295 20 13.3 20 9.953c0-3.312-1.418-5.364-3.198-6.543C15.087 2.274 13.123 2 12 2zm.438 17.357c-.162.14-.309.264-.438.37a23.521 23.521 0 01-2.745-2.673C7.551 15.09 6 12.563 6 9.955c0-2.641 1.082-4.067 2.302-4.876C9.587 4.226 11.123 4 12 4c.877 0 2.413.226 3.697 1.078C16.919 5.887 18 7.313 18 9.954c0 2.608-1.55 5.136-3.255 7.1a23.516 23.516 0 01-2.307 2.303zM10 10a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgPin);
export default ForwardRef;
